import React, { useEffect, useState } from "react";
import NetaqInput from "./NetaqInput";
import SubmitBtn from "./SubmitBtn";
import dayjs, { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { FetchStudBookCountriesthunk } from "../Redux/StudBook/StudBookAction";
import { useTranslate } from "./TranslationText";
import Select from "react-select";
import NewActionButton from "./ActionButtons/NewActionButton";
import { filterButtonsContainer, filterCard, filterHeader, filterResetBtn, filterSubmitBtn } from "../common/cssclasses";
import axiosInstance from "../axios/axios";
import { toSafeISOString } from "../helper/timeUtils";
const isTestApp = process.env.REACT_APP_IS_TEST;

const StudBookFilter = ({ onSubmit, regNo, setRN, filterCriteria }) => {
  const { studBookCountries, currentLanguage } = useSelector(
    (state) => state.studBookSlice
  );

  const dispatch = useDispatch();
  const { translate } = useTranslate();

  const bestHorseOptions = [
    {
      label: translate('web.thehorse', 'horse'),
      text: translate('web.thehorse', 'horse'),
      value: "Horse"
    },
    {
      label: translate('web.sire', 'sire'),
      text: translate('web.sire', 'sire'),
      value: "Sire"
    },
    {
      label: translate('web.dam', 'dam'),
      text: translate('web.dam', 'dam'),
      value: "Dam"
    },
  ];

  const searchWayOptions = [
    {
      label: translate('web.bestHorsesWay', 'bestHorsesWay'),
      text: translate('web.bestHorsesWay', 'bestHorsesWay'),
      value: "BestWay"
    },
    {
      label: translate('web.rankWay', 'rankWay'),
      text: translate('web.rankWay', 'rankWay'),
      value: "RankWay"
    },
    {
      label: translate('web.medalWay', 'medalWay'),
      text: translate('web.medalWay', 'medalWay'),
      value: "MedalWay"
    },
  ];

  const medals = [
    {
      label: translate('web.gold', 'gold'),
      text: translate('web.gold', 'gold'),
      value: "Gold"
    },
    {
      label: translate('web.Silver', 'Silver'),
      text: translate('web.Silver', 'Silver'),
      value: "Silver"
    },
    {
      label: translate('web.Bronze', 'Bronze'),
      text: translate('web.Bronze', 'Bronze'),
      value: "Bronze"
    },
  ];

  const [showsCategories, setShowsCategories] = useState([]);

  useEffect(() => {
    dispatch(FetchStudBookCountriesthunk(currentLanguage));
    getShowsCategories();
  }, [currentLanguage]);

  const [searchType, setSearchType] = useState(() => {
    if (filterCriteria?.IsBestSearch) return "BestHorses";
    if (filterCriteria?.isFlatRace) return "FlatRaces";
    if (filterCriteria?.isEndurance) return "Endurance";
    return sessionStorage.getItem("sbf_searchType") || "None";
  });

  const [birthDateFrom, setBirthdateFrom] = useState(() => {
    const val = filterCriteria?.birthDateFrom || sessionStorage.getItem("sbf_birthDateFrom");
    return val && dayjs(val).isValid() ? dayjs(val) : null;
  });

  const [birthDateTo, setBirthdateTo] = useState(() => {
    const val = filterCriteria?.birthDateTo || sessionStorage.getItem("sbf_birthDateTo");
    return val && dayjs(val).isValid() ? dayjs(val) : null;
  });

  const [showRangeFrom, setShowRangeFrom] = useState(() => {
    const val = filterCriteria?.ShowsFrom || sessionStorage.getItem("sbf_showRangeFrom");
    return val && dayjs(val).isValid() ? dayjs(val) : dayjs().subtract(1, "year");
  });

  const [showRangeTo, setShowRangeTo] = useState(() => {
    const val = filterCriteria?.ShowsTo || sessionStorage.getItem("sbf_showRangeTo");
    return val && dayjs(val).isValid() ? dayjs(val) : dayjs();
  });

  const [searchWay, setSearchWay] = useState(() => {
    const saved = sessionStorage.getItem("sbf_searchWay");
    if (saved) {
      try { return JSON.parse(saved); } catch (e) {}
    }
    if (filterCriteria?.SearchWay) {
      const found = searchWayOptions.find(o => o.value === filterCriteria.SearchWay);
      if (found) return found;
    }
    return searchWayOptions[0];
  });

  const [selectedBestHorse, setSelectedBestHorse] = useState(() => {
    const saved = sessionStorage.getItem("sbf_selectedBestHorse");
    if (saved) {
      try { return JSON.parse(saved); } catch (e) {}
    }
    if (filterCriteria?.HorseSearchType) {
      const found = bestHorseOptions.find(o => o.value === filterCriteria.HorseSearchType);
      if (found) return found;
    }
    return bestHorseOptions[0];
  });

  const [selectedCategories, setSelectedShowsCategories] = useState(() => {
    const saved = sessionStorage.getItem("sbf_selectedCategories");
    if (saved) {
      try { return JSON.parse(saved); } catch (e) {}
    }
    return [];
  });

  const [selectedMedals, setSelectedMedals] = useState(() => {
    const saved = sessionStorage.getItem("sbf_selectedMedals");
    if (saved) {
      try { return JSON.parse(saved); } catch (e) {}
    }
    if (filterCriteria?.MedalsList?.length > 0) {
      return medals.filter(m => filterCriteria.MedalsList.includes(m.value));
    }
    return [];
  });

  const initialFilterState = {
    gender: filterCriteria?.gender || [],
    registrationNumber: regNo || filterCriteria?.regNo || "",
    origin: filterCriteria?.origin ?? null,
    originDrop: filterCriteria?.originDrop || {
      label: translate("web.chooseOrigin", "Choose Origin"),
      value: null,
    },
    ownerId: filterCriteria?.ownerRegisterNumber || filterCriteria?.ownerId || "",
    birthDateFrom: filterCriteria?.birthDateFrom ?? null,
    birthDateTo: filterCriteria?.birthDateTo ?? null,
    IsBestSearch: filterCriteria?.IsBestSearch ?? false,
    isFlatRace: filterCriteria?.isFlatRace ?? false,
    isEndurance: filterCriteria?.isEndurance ?? false,
    isLeased: filterCriteria?.isLeased ?? null,
    HorseSearchType: filterCriteria?.HorseSearchType ?? selectedBestHorse?.value,
    ShowsFrom: filterCriteria?.ShowsFrom ?? toSafeISOString(showRangeFrom),
    ShowsTo: filterCriteria?.ShowsTo ?? toSafeISOString(showRangeTo),
    ShowRankIds: filterCriteria?.ShowRankIds || [],
    SearchWay: filterCriteria?.SearchWay ?? searchWay?.value,
    RankFrom: filterCriteria?.RankFrom ?? 1,
    RankTo: filterCriteria?.RankTo ?? 10,
    MedalsList: filterCriteria?.MedalsList ?? null,
  };

  const [filterState, setFilterState] = useState(() => {
    const saved = sessionStorage.getItem("sbf_filterState");
    return saved ? { ...initialFilterState, ...JSON.parse(saved) } : initialFilterState;
  });

  useEffect(() => { sessionStorage.setItem("sbf_searchType", searchType); }, [searchType]);
  useEffect(() => { if (birthDateFrom) sessionStorage.setItem("sbf_birthDateFrom", birthDateFrom.toISOString()); else sessionStorage.removeItem("sbf_birthDateFrom"); }, [birthDateFrom]);
  useEffect(() => { if (birthDateTo) sessionStorage.setItem("sbf_birthDateTo", birthDateTo.toISOString()); else sessionStorage.removeItem("sbf_birthDateTo"); }, [birthDateTo]);
  useEffect(() => { if (showRangeFrom) sessionStorage.setItem("sbf_showRangeFrom", showRangeFrom.toISOString()); else sessionStorage.removeItem("sbf_showRangeFrom"); }, [showRangeFrom]);
  useEffect(() => { if (showRangeTo) sessionStorage.setItem("sbf_showRangeTo", showRangeTo.toISOString()); else sessionStorage.removeItem("sbf_showRangeTo"); }, [showRangeTo]);
  useEffect(() => { sessionStorage.setItem("sbf_searchWay", JSON.stringify(searchWay)); }, [searchWay]);
  useEffect(() => { sessionStorage.setItem("sbf_selectedBestHorse", JSON.stringify(selectedBestHorse)); }, [selectedBestHorse]);
  useEffect(() => { sessionStorage.setItem("sbf_selectedCategories", JSON.stringify(selectedCategories)); }, [selectedCategories]);
  useEffect(() => { sessionStorage.setItem("sbf_selectedMedals", JSON.stringify(selectedMedals)); }, [selectedMedals]);
  useEffect(() => { sessionStorage.setItem("sbf_filterState", JSON.stringify(filterState)); }, [filterState]);

  useEffect(() => {
    if (filterCriteria) {
      setFilterState(prev => ({
        ...prev,
        ...filterCriteria,
        gender: filterCriteria.gender || prev.gender || [],
        ownerId: filterCriteria.ownerRegisterNumber || filterCriteria.ownerId || prev.ownerId || "",
        registrationNumber: regNo || filterCriteria.registrationNumber || filterCriteria.regNo || prev.registrationNumber,
      }));
      if (filterCriteria.birthDateFrom && dayjs(filterCriteria.birthDateFrom).isValid()) {
        setBirthdateFrom(dayjs(filterCriteria.birthDateFrom));
      }
      if (filterCriteria.birthDateTo && dayjs(filterCriteria.birthDateTo).isValid()) {
        setBirthdateTo(dayjs(filterCriteria.birthDateTo));
      }
      if (filterCriteria.ShowsFrom && dayjs(filterCriteria.ShowsFrom).isValid()) {
        setShowRangeFrom(dayjs(filterCriteria.ShowsFrom));
      }
      if (filterCriteria.ShowsTo && dayjs(filterCriteria.ShowsTo).isValid()) {
        setShowRangeTo(dayjs(filterCriteria.ShowsTo));
      }
      if (filterCriteria.IsBestSearch) {
        setSearchType('BestHorses');
      } else if (filterCriteria.isFlatRace) {
        setSearchType('FlatRaces');
      } else if (filterCriteria.isEndurance) {
        setSearchType('Endurance');
      }
    }
  }, [filterCriteria, regNo]);

  useEffect(() => {
    if (regNo !== undefined) {
      setFilterState(prev => ({
        ...prev,
        registrationNumber: regNo,
      }));
    }
  }, [regNo]);

  useEffect(() => {
    if (studBookCountries?.length > 0 && filterState.origin && (!filterState.originDrop || !filterState.originDrop.value)) {
      const country = studBookCountries.find(c => c.value == filterState.origin);
      if (country) {
        setFilterState(prev => ({
          ...prev,
          originDrop: {
            label: country.text,
            value: country.value,
          }
        }));
      }
    }
  }, [studBookCountries, filterState.origin]);

  useEffect(() => {
    if (showsCategories?.length > 0 && filterState.ShowRankIds?.length > 0 && selectedCategories?.length === 0) {
      const matched = showsCategories.filter(sc => filterState.ShowRankIds.includes(sc.value));
      if (matched.length > 0) {
        setSelectedShowsCategories(matched);
      }
    }
  }, [showsCategories, filterState.ShowRankIds]);

  const handleRadioChange = (type) => {
    setSearchType(type);

    // Clear sub-filters if switching away from BestHorses
    if (type !== 'BestHorses') {
      setSelectedBestHorse(bestHorseOptions[0]);
      setSearchWay(searchWayOptions[0]);
      setShowRangeFrom(dayjs().subtract(1, "year"));
      setShowRangeTo(dayjs());
      setSelectedShowsCategories([]);
      setSelectedMedals([]);
    }

    setFilterState(prev => ({
      ...prev,
      IsBestSearch: type === 'BestHorses',
      isFlatRace: type === 'FlatRaces',
      isEndurance: type === 'Endurance'
    }));
  };

  const handleChange = (event, input) => {

    if (!!input && input === "birthDateFrom") {
      let currentTo = birthDateTo;
      if (event && currentTo && event.isAfter(currentTo)) {
        currentTo = event;
        setBirthdateTo(event);
      }
      setBirthdateFrom(event);
      setFilterState(prev => ({
        ...prev,
        birthDateFrom: toSafeISOString(event),
        birthDateTo: toSafeISOString(currentTo),
      }));
      return;
    }
    if (!!input && input === "birthDateTo") {
      let currentVal = event;
      if (event && birthDateFrom && event.isBefore(birthDateFrom)) {
        currentVal = birthDateFrom;
      }
      if (event && event.isAfter(dayjs())) {
        currentVal = dayjs();
      }
      setBirthdateTo(currentVal);
      setFilterState(prev => ({
        ...prev,
        birthDateTo: toSafeISOString(currentVal),
      }));
      return;
    }
    if (!!input && input === "origin") {
      setFilterState(prev => ({
        ...prev,
        origin: event?.value ?? null,
        originDrop: event,
      }));
      return;
    }

    if (event.target.name === "RankFrom") {
      let val = event.target.value;
      if (val !== "") {
        val = parseInt(val, 10);
        if (filterState.RankTo !== "" && filterState.RankTo !== null && val > parseInt(filterState.RankTo, 10)) {
          val = parseInt(filterState.RankTo, 10);
        }
      }
      setFilterState(prev => ({ ...prev, RankFrom: val }));
      return;
    }

    if (event.target.name === "RankTo") {
      let val = event.target.value;
      if (val !== "") {
        val = parseInt(val, 10);
        if (filterState.RankFrom !== "" && filterState.RankFrom !== null && val < parseInt(filterState.RankFrom, 10)) {
          val = parseInt(filterState.RankFrom, 10);
        }
      }
      setFilterState(prev => ({ ...prev, RankTo: val }));
      return;
    }

    if (event.target.name === "registrationNumber") {
      setRN(event.target.value);
      setFilterState(prev => ({
        ...prev,
        registrationNumber: event.target.value,
      }));
      return;
    }

    if (event.target.name === "gender") {
      const val = parseInt(event.target.value, 10);
      if (!event.target.checked) {
        setFilterState(prev => ({
          ...prev,
          gender: (prev.gender || []).filter((item) => item !== val),
        }));
      } else {
        setFilterState(prev => ({
          ...prev,
          gender: (prev.gender || []).includes(val) ? prev.gender : [...(prev.gender || []), val],
        }));
      }
      return;
    }

    setFilterState(prev => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = (event) => {
    window.scrollTo(0, 0);
    event.preventDefault();
    const finalState = {
      ...filterState,
      registrationNumber: regNo || filterState.registrationNumber || "",
      regNo: regNo || filterState.registrationNumber || "",
    };
    onSubmit(finalState);
  };

  const handleReset = (event) => {
    setBirthdateFrom(null);
    setBirthdateTo(null);
    setShowRangeFrom(dayjs().subtract(1, "year"));
    setShowRangeTo(dayjs());
    setRN("");
    setSearchType('None');
    setSelectedBestHorse(bestHorseOptions[0]);
    setSearchWay(searchWayOptions[0]);
    setSelectedShowsCategories([]);
    setSelectedMedals([]);

    const emptyFilter = {
      gender: [],
      horseUELN: "",
      origin: null,
      originDrop: {
        label: translate("web.chooseOrigin", "Choose Origin"),
        value: null,
      },
      ownerId: "",
      birthDateFrom: null,
      birthDateTo: null,
      IsBestSearch: false,
      isFlatRace: false,
      isEndurance: false,
      isLeased: null,
      HorseSearchType: "Horse",
      ShowsFrom: toSafeISOString(dayjs().subtract(1, "year")),
      ShowsTo: toSafeISOString(dayjs()),
      ShowRankIds: [],
      SearchWay: "BestWay",
      RankFrom: 1,
      RankTo: 10,
      MedalsList: null,
      registrationNumber: "",
    };

    setFilterState(emptyFilter);

    sessionStorage.removeItem("sbf_filterState");
    sessionStorage.removeItem("sbf_searchType");
    sessionStorage.removeItem("sbf_birthDateFrom");
    sessionStorage.removeItem("sbf_birthDateTo");
    sessionStorage.removeItem("sbf_showRangeFrom");
    sessionStorage.removeItem("sbf_showRangeTo");
    sessionStorage.removeItem("sbf_searchWay");
    sessionStorage.removeItem("sbf_selectedBestHorse");
    sessionStorage.removeItem("sbf_selectedCategories");
    sessionStorage.removeItem("sbf_selectedMedals");
    sessionStorage.removeItem("sb_regNo");
    sessionStorage.removeItem("sb_filterCriteria");

    onSubmit(emptyFilter);
  };


  async function getShowsCategories() {
    try {
      const res = await axiosInstance.get('/lookup/getshowranks');
      if (res.data?.responseCode == "200") {
        const formattedData = res.data?.result?.map((x) => ({
          label: x?.showRankName,
          text: x?.showRankName,
          value: x?.id,
        }))
        setShowsCategories(formattedData);
      } else {
        setShowsCategories([]);
      }

    } catch (error) {
      console.error('Error in Ranks', error)
    }

  }


  return (
    <form
      className={filterCard}
      onSubmit={handleSubmit}
      onReset={handleReset}
    >
      <h2 className={filterHeader}>{translate('web.advancedSearch', 'Advanced Search')}</h2>
      <div className="mb-form-group">
        <NetaqInput
          name={"registrationNumber"}
          label={translate("web.horseNameNumber", "Horse Name | Number")}
          placeholder={translate("web.horseNameNumber", "Horse Name | Number")}
          type={"text"}
          value={regNo || filterState.registrationNumber || ""}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group">
        <NetaqInput
          name={"ownerId"}
          label={translate("web.ownerNameOrNumber", "Owner Name | Number")}
          placeholder={translate("web.ownerNameOrNumber", "Owner Name | Number")}
          type={"text"}
          value={filterState.ownerId || ""}
          onChange={handleChange}
        />
      </div>
      <div className="mb-form-group">
        <label className="">{translate("web.gender", "Gender")}</label>
        <div className="AuctionFilterNumberofhoursesContainer" style={{ flexWrap: 'wrap' }}>
          <NetaqInput
            id={"gender_mare"}
            name={"gender"}
            type={"checkbox"}
            value={1}
            checked={filterState.gender?.includes(1) || false}
            label={translate("web.mare", "Mare")}
            onChange={handleChange}
          />

          <NetaqInput
            id={"gender_stallion"}
            name={"gender"}
            type={"checkbox"}
            value={2}
            checked={filterState.gender?.includes(2) || false}
            label={translate("web.stallion", "Stallion")}
            onChange={handleChange}
          />

          <NetaqInput
            id={"gender_gelding"}
            name={"gender"}
            type={"checkbox"}
            value={3}
            checked={filterState.gender?.includes(3) || false}
            label={translate("web.gelding", "Gelding")}
            onChange={handleChange}
          />
        </div>
      </div>
      {/* <div className="mb-form-group">
        <NetaqInput
          name="isLeased"
          type="checkbox"
          label={translate("web.isHorseLeased", "")}
          checked={filterState.isLeased === true}
          onChange={(e) => setFilterState({ ...filterState, isLeased: e.target.checked ? true : null })}
        />
      </div> */}
      <div className="mb-form-group">
        <div className="row">
          <div className="col-6">
            <NetaqInput
              name={"birthDateFrom"}
              type={"date"}
              label={
                <>
                  {translate("web.birthDate", "Birthdate")} {translate("web.from", "From")}
                </>
              }
              onChange={handleChange}
              value={birthDateFrom}
              maxDate={birthDateTo || dayjs()}
            />
          </div>
          <div className="col-6">
            <NetaqInput
              name={"birthDateTo"}
              type={"date"}
              label={
                <>
                  {translate("web.birthDate", "Birthdate")} {translate("web.to", "To")}
                </>
              }
              onChange={handleChange}
              value={birthDateTo}
              minDate={birthDateFrom}
              maxDate={dayjs()}
            />
          </div>
        </div>
      </div>


      <div className="mb-form-group">
        <NetaqInput type={'select'}
          label={translate("web.origin", "Origin")}
          listSelect={[
            {
              label: translate("web.chooseOrigin", "Choose Origin"),
              value: null,
            },
            ...(Array.isArray(studBookCountries)
              ? studBookCountries.map((a) => ({
                  label: a.text,
                  value: a.value,
                }))
              : []),
          ]}
          value={filterState.originDrop}
          onChange={(e) => handleChange(e, "origin")}
          placeholder={translate("web.chooseOrigin", "Choose Origin")}
          name={"origin"}
          noOptionsMessage={() => translate("web.noOptions", "No Options")}
        />
      </div>
      {
        <>
          <div className="dropdown-divider mb-form-group" ></div>

          <div className="mb-form-group">
            {/* <label className="form-label d-block capatalize_text fw-bold">
              {translate("web.searchOptions", "Search Options")}
            </label> */}
            <div className="d-flex flex-column gap-2 mt-2">
              <div className="form-check">
                <input type="radio" className="form-check-input"
                  id="searchOption-bestHorses"
                  name="searchOption"
                  checked={searchType === 'BestHorses'}
                  onChange={() => handleRadioChange('BestHorses')}
                  style={{ cursor: 'pointer' }}
                />
                <label className="form-check-label" htmlFor="searchOption-bestHorses" style={{ cursor: 'pointer' }}>
                  {translate("web.findBestHorses", "Best Horses")}
                </label>
              </div>

              <div className="form-check">
                <input type="radio" className="form-check-input"
                  id="searchOption-flatRaces"
                  name="searchOption"
                  checked={searchType === 'FlatRaces'}
                  onChange={() => handleRadioChange('FlatRaces')}
                  style={{ cursor: 'pointer' }}
                />
                <label className="form-check-label" htmlFor="searchOption-flatRaces" style={{ cursor: 'pointer' }}>
                  {translate("web.flatRaces", "Flat Races")}
                </label>
              </div>

              <div className="form-check">
                <input type="radio" className="form-check-input"
                  id="searchOption-endurance"
                  name="searchOption"
                  checked={searchType === 'Endurance'}
                  onChange={() => handleRadioChange('Endurance')}
                  style={{ cursor: 'pointer' }}
                />
                <label className="form-check-label" htmlFor="searchOption-endurance" style={{ cursor: 'pointer' }}>
                  {translate("web.endurance", "Endurance")}
                </label>
              </div>
            </div>
          </div>

          {searchType === 'BestHorses' &&
            <>
              <div className="mb-form-group">
                <NetaqInput type={'select'}
                  label={translate("web.searchfor", "Search For")}
                  listSelect={bestHorseOptions}
                  placeholder={translate("web.searchfor", "Search For")}
                  name={"horseSearch"}
                  value={selectedBestHorse}
                  onChange={(selectedItem) => {
                    setSelectedBestHorse(selectedItem);
                    setFilterState({
                      ...filterState,
                      HorseSearchType: selectedItem?.value,
                    });
                  }}
                  noOptionsMessage={() => translate("web.noOptions", "No Options")}
                />
              </div>
              <div className={`mb-form-group`}>
                <NetaqInput type={'select'}
                  label={translate("web.searchWay", "searchWay")}
                  listSelect={searchWayOptions}
                  placeholder={translate("web.searchWay", "searchWay")}
                  onChange={(selected) => {
                    setSearchWay(selected);
                    setFilterState({
                      ...filterState,
                      SearchWay: selected?.value,
                    });
                  }}
                  name={"horseSearch"}
                  value={searchWay}
                  noOptionsMessage={() => translate("web.noOptions", "No Options")}
                />
              </div>
              {searchWay?.value == "RankWay" &&
                <>
                  <div className="mb-form-group-last">
                    <div className="row">
                      <div className="col-6">
                        <NetaqInput
                          name={"RankFrom"}
                          type={"number"}
                          label={
                            <>
                              {translate("web.rank", "rank")} {translate("web.from", "From")}
                            </>
                          }
                          placeholder={'1'}
                          value={filterState.RankFrom}
                          onChange={handleChange}
                          minValue={1}
                        />
                      </div>
                      <div className="col-6">
                        <NetaqInput
                          name={"RankTo"}
                          type={"number"}
                          label={
                            <>
                              {translate("web.rank", "rank")} {translate("web.to", "To")}
                            </>
                          }
                          placeholder={'10'}
                          onChange={handleChange}
                          value={filterState.RankTo}
                          minValue={filterState.RankFrom || 1}
                        />
                      </div>
                    </div>
                  </div>
                </>
              }
              {searchWay?.value == "MedalWay" &&
                <>
                  <div className={`mb-form-group-last`}>
                    <NetaqInput type={'select'}
                      label={translate("web.medals", "medals")}
                      listSelect={medals}
                      isClearable
                      isMulti
                      placeholder={translate("web.medals", "medals")}
                      onChange={(selected) => {
                        setSelectedMedals(selected);
                        const values = selected?.map((x) => (x?.value)) ?? [];
                        setFilterState({
                          ...filterState,
                          MedalsList: values,
                        });
                      }}
                      value={selectedMedals}
                      name={"horseSearch"}
                      noOptionsMessage={() => translate("web.noOptions", "No Options")}
                    />
                  </div>
                </>
              }
              <div className="mb-form-group">
                <div className="row">
                  <div className="col-6">
                    <NetaqInput
                      name={"showDateFrom"}
                      type={"date"}
                      label={
                        <>
                          {translate("web.showRange", "showRange")} {translate("web.from", "From")}
                        </>
                      }
                      onChange={(event) => {
                        let currentTo = showRangeTo;
                        if (event && currentTo && event.isAfter(currentTo)) {
                          currentTo = event;
                          setShowRangeTo(event);
                        }
                        setShowRangeFrom(event);
                        setFilterState(prev => ({
                          ...prev,
                          ShowsFrom: toSafeISOString(event),
                          ShowsTo: toSafeISOString(currentTo),
                        }));
                      }}
                      value={showRangeFrom}
                      maxDate={showRangeTo || dayjs()}
                    />
                  </div>
                  <div className="col-6">
                    <NetaqInput
                      name={"showDateTo"}
                      type={"date"}
                      label={
                        <>
                          {translate("web.showRange", "showRange")} {translate("web.to", "To")}
                        </>
                      }
                      onChange={(event) => {
                        let currentVal = event;
                        if (event && showRangeFrom && event.isBefore(showRangeFrom)) {
                          currentVal = showRangeFrom;
                        }
                        if (event && event.isAfter(dayjs())) {
                          currentVal = dayjs();
                        }
                        setShowRangeTo(currentVal);
                        setFilterState(prev => ({
                          ...prev,
                          ShowsTo: toSafeISOString(currentVal),
                        }));
                      }}
                      value={showRangeTo}
                      minDate={showRangeFrom}
                      maxDate={dayjs()}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-form-group">
                <NetaqInput type={'select'}
                  label={translate("web.showCategoties", "Show Categoties")}
                  listSelect={showsCategories}
                  isClearable
                  isMulti
                  placeholder={translate("web.showCategoties", "Show Categoties")}
                  name={"horseSearch"}
                  value={selectedCategories}
                  noOptionsMessage={() => translate("web.noOptions", "No Options")}
                  onChange={(selectedItem) => {
                    setSelectedShowsCategories(selectedItem)
                    const values = selectedItem?.map((x) => (x?.value)) ?? [];
                    setFilterState({
                      ...filterState,
                      ShowRankIds: values,
                    });
                  }}
                />
              </div>

            </>
          }
        </>}


      <div className={filterButtonsContainer} >
        <div className={filterResetBtn}>
          <NewActionButton
            key={"reset"}
            isButton
            classNames="btn-outline-secondary"

            type={"reset"}
            text={translate('web.reset', 'Reset')}
          />
        </div>
        <div className={filterSubmitBtn}>
          <NewActionButton
            isButton
            classNames="btn-danger"
            text={translate("web.search", "Search")}
            key={"apply"}
            type={"submit"}
          // disabled={
          //   filterState.gender.length === 0 &&
          //   filterState.origin === null &&
          //   filterState.registrationNumber === "" &&
          //   filterState.ownerId === "" &&
          //   filterState.birthDateFrom === null &&
          //   filterState.birthDateTo === null
          // }
          />
        </div>
      </div>
    </form>
  );
};

export default StudBookFilter;
